const Dropdown = ({
  label,
  value,
  onChange,
  options = [],
  labelKey,
  valueKey,
}) => {
  return (
    <div className="flex items-center gap-2 w-full sm:w-60">
      <label className="text-md text-gray-700 whitespace-nowrap">{label}</label>
      <select
        className="border px-2 py-2 rounded w-full focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select {label}</option>
        {options.map((opt) => (
          <option key={opt[valueKey]} value={opt[valueKey]}>
            {opt[labelKey]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
